function hideScroller() {
  actionbtn = $('.add-to-cart');
 var sub = $('#smsbump-form-55492');
    actionfromtop = actionbtn.offset().top +1730;
    subfromtop = $(window).scrollTop()+$(window).height();

  if (actionfromtop > subfromtop) { sub.hide(); }
  else { sub.show(); }
}

function pshideScroller() {
  actionbtn = $('.add-to-cart');
 var sub = $('#ps__widget_container');
    actionfromtop = actionbtn.offset().top +1730;
    subfromtop = $(window).scrollTop()+$(window).height();

  if (actionfromtop > subfromtop) { sub.hide(); }
  else { sub.show(); }
}


$(document).ready(function () {
    hideScroller(); 
    pshideScroller();
    });
$(window).scroll(function () {
   hideScroller();  
   pshideScroller();
});
